/**
 * @param marker {CustomMarker}
 * @returns {string}
 */
export function customMarkerTemplateIcon(marker) {
    return `
            <div class="custom-marker-icon">
               Custom marker template icon with attributes ${marker.attributes}
            </div>
        `;
}
